import React from "react";

import { Button, ButtonTypes } from "@/component-library";
import CloseOnOutsideClick from "@/components/Common/CloseOnOutsideClick/CloseOnOutsideClick";

import "./DeleteNote.styles.scss";

export function DeleteNote(props) {
  return (
    <div className="DeleteNoteModal--body">
      <CloseOnOutsideClick className="DeleteNoteModal--inner" setShowComponent={props.close}>
        <div>
          <h5 className="text-center fs-17 m-0 DeleteNoteModal--title tw:font-bold">Delete Note</h5>
          <span className="text-center">Are you sure you want to delete this Progress Note?</span>
        </div>

        <div className="DeleteNoteModal--footer">
          <Button buttonType={ButtonTypes.primaryOutlineV2} onClick={props.close}>
            Cancel
          </Button>

          <Button buttonType={ButtonTypes.primaryV2} onClick={props.clickHandler}>
            Delete
          </Button>
        </div>
      </CloseOnOutsideClick>
    </div>
  );
}
